'use client';

import { Content, isFilled } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { SliceComponentProps } from '@prismicio/react';

import { wrapper, image } from './imageBlock.css';

export type ImageBlockProps = SliceComponentProps<Content.ImageBlockSlice>;

const ImageBlock = ({ slice }: ImageBlockProps): JSX.Element | null => {
  if (!isFilled.image(slice.primary.image)) {
    return null;
  }

  return (
    <div
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      style={{
        backgroundColor: isFilled.color(slice.primary.background_color)
          ? slice.primary.background_color
          : 'transparent',
      }}
      className={wrapper}
    >
      <PrismicNextImage
        fallbackAlt=""
        field={slice.primary.image}
        className={image}
      />
    </div>
  );
};

export default ImageBlock;
